import SocialKit from "@/components/SocialKit";
import Seo from "@/components/Seo";

export default function SocialKitPage() {
  return (
    <div className="bg-[var(--ff-bg)] min-h-screen" data-testid="social-kit-page">
      <Seo title="Black Friday Social Kit · The Farm To You" path="/social-kit" />
      <div className="max-w-6xl mx-auto px-6 py-12 sm:py-16">
        <p className="overline text-[var(--ff-primary)]">Share &amp; grow</p>
        <SocialKit />
      </div>
    </div>
  );
}
